import AWS from 'aws-sdk';

const BUCKET_NAME = 'org.axpx.aiagentkb';
const BUCKET_REGION = 'us-east-1';
var s3 = null;
var identityId = null;
var sub = null;

AWS.config.region = BUCKET_REGION;

export const setS3CognitoUserCredentials = (creds, s) => {
  AWS.config.credentials = creds;
  s3 = new AWS.S3();
  identityId = AWS.config.credentials.identityId;
  sub = s;
}

export const uploadFileChunk = (fileData, uploadInfo, destinationDirectory) => {
  let promise = null;
  if (uploadInfo.chunkIndex === 0) {
    const filePath = destinationDirectory.path ? `${destinationDirectory.path}/${fileData.name}` : fileData.name;
    promise = s3
        .createMultipartUpload({
          Bucket: BUCKET_NAME,
          Key: filePath
         })
        .promise()
        .then((response) => {
            uploadInfo.customData.uploadId = response.UploadId;
            uploadInfo.customData.key = response.Key;
        });
  } else {
    promise = Promise.resolve();
  }
  promise = promise.then(() => {
    return s3.uploadPart({
       Body: uploadInfo.chunkBlob,
       Bucket: BUCKET_NAME,
       Key: uploadInfo.customData.key,
       PartNumber: uploadInfo.chunkIndex + 1,
       UploadId: uploadInfo.customData.uploadId
     }).promise()
  })
  promise = promise.then((response) => {
     return response
  });
  if (uploadInfo.chunkIndex === uploadInfo.chunkCount - 1) {
    promise = promise.then(() => {
      return s3.listParts({
       Bucket: BUCKET_NAME,
       Key: uploadInfo.customData.key,
       UploadId: uploadInfo.customData.uploadId
     }).promise()
    });
    promise = promise.then((response) => {
       const parts = []
       response.Parts.forEach((c) => {
         parts.push({
           ETag: c.ETag,
           PartNumber: c.PartNumber
         });
        });
       uploadInfo.customData.parts = parts
       return s3.completeMultipartUpload({
          Bucket: BUCKET_NAME,
          Key: uploadInfo.customData.key,
          MultipartUpload: {Parts: uploadInfo.customData.parts},
          UploadId: uploadInfo.customData.uploadId
        }).promise()
    }).then((response) => {
      }).catch((error) => {
        console.log(error)
      });
  }
  return promise;
}

export const deleteItem = async (item) => {
  if (item.isDirectory) {
    let listParams = {
      Bucket: BUCKET_NAME,
      Prefix: item.key,
    };
    let listedObjects;
    do {
      listedObjects = await s3.listObjectsV2(listParams).promise();
      if (listedObjects.Contents.length > 0) {
        const deleteParams = {
          Bucket: BUCKET_NAME,
          Delete: {
            Objects: listedObjects.Contents.map(({ Key }) => ({ Key })),
          },
        };
        await s3.deleteObjects(deleteParams).promise();
      }
      if (listedObjects.IsTruncated) {
        listParams.ContinuationToken = listedObjects.NextContinuationToken;
      }
    } while (listedObjects.IsTruncated);
  } else {
    return s3
      .deleteObject({
        Bucket: BUCKET_NAME,
        Key: item.key,
      })
      .promise();
  }
};

export const createDirectory = (parentDirectory, name) => {
  const key = parentDirectory.path ? `${parentDirectory.path}/${name}/` : `${name}/`;
  return s3
      .putObject({
          Bucket: BUCKET_NAME,
          Key: key,
      })
      .promise();
}

export const downloadItems = (items) => {
  for (const item of items) {
    if (!item.isDirectory) {
      const link = document.createElement('a');
      link.href = s3.getSignedUrl('getObject', { Bucket: BUCKET_NAME, Key: item.key });
      link.download = item.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

export const renameItem = (item, newName) => {
  const newKey = item.key.replace(item.name, newName);
  return s3.copyObject({
      Bucket: BUCKET_NAME,
      CopySource: `${BUCKET_NAME}/${item.key}`,
      Key: newKey,
    })
    .promise()
    .then(() => {
      return s3.deleteObject({
          Bucket: BUCKET_NAME,
          Key: item.key,
        })
        .promise();
    });
};

export const copyItem = (item, destinationDirectory) => {
  const newKey = `${destinationDirectory.path ? destinationDirectory.path + '/' : ''}${item.name}`;
  return s3.copyObject({
      Bucket: BUCKET_NAME,
      CopySource: `${BUCKET_NAME}/${item.key}`,
      Key: newKey,
    })
    .promise();
};

export const getItems = (pathInfo) => {
    const prefix = pathInfo.path ? `${pathInfo.path}/` : '';
    return s3
        .listObjectsV2({
            Bucket: BUCKET_NAME,
            Delimiter: '/',
            Prefix: prefix,
        })
        .promise()
        .then((response) => {
            const files = [];
            const s3Objects = response.Contents.filter(element => {return element.Key !== prefix});
            const s3Prefixes = response.CommonPrefixes;

            if (s3Objects) {
                files.push(
                    ...s3Objects.map(
                        (object) => ({
                            key: object.Key,
                            name: object.Key.split('/').reverse()[0],
                            isDirectory: false,
                            size: object.Size,
                            modifiedDate: object.LastModified,
                        })
                    )
                );
            }

            if (s3Prefixes) {
                files.push(
                    ...s3Prefixes.map(
                        (prefix) => ({
                            key: prefix.Prefix,
                            name: prefix.Prefix.split('/').slice(-2)[0],
                            isDirectory: true,
                        })
                    )
                );
            }

            return files;
        });
};

export const getAllKBFiles = async () => {
  if (!s3) {
    return [];
  }
  let allFiles = [];
  let continuationToken = null;
  do {
    const params = {
      Bucket: BUCKET_NAME,
    };
    if (continuationToken) {
      params.ContinuationToken = continuationToken;
    }
    const res = await s3.listObjectsV2(params).promise();
    if (res.Contents) {
      const files = res.Contents
        .filter((element) => {
          // exclude directory marker objects and .metadata.json companion files
          return !element.Key.endsWith('/') && !element.Key.endsWith('.metadata.json');
        })
        .map((object) => {
          const parts = object.Key.split('/');
          const name = parts[parts.length - 1];
          const folder = parts.length > 1 ? parts.slice(0, -1).join('/') : '/';
          return {
            key: object.Key,
            name: name,
            folder: folder,
            size: object.Size,
            lastModified: object.LastModified,
          };
        });
      allFiles.push(...files);
    }
    continuationToken = res.IsTruncated ? res.NextContinuationToken : null;
  } while (continuationToken);

  return allFiles;
};

export const downloadFile = (key, name) => {
  if (!s3) return;
  const fileName = name || key.split('/').pop();
  const link = document.createElement('a');
  link.href = s3.getSignedUrl('getObject', {
    Bucket: BUCKET_NAME,
    Key: key,
    ResponseContentDisposition: `attachment; filename="${fileName}"`,
  });
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const uploadFolderFile = (file, key) => {
  if (!s3) {
    return Promise.reject(new Error('S3 is not initialized'));
  }
  return s3
    .upload({
      Bucket: BUCKET_NAME,
      Key: key,
      Body: file,
    })
    .promise();
};
